import { Ionicons } from '@expo/vector-icons';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import AppConstants from '../AppConstants';
import { useJourney } from '../contexts/JourneyContext';
import { useMediaPlayer } from '../contexts/MediaPlayerContext';
import ContentItemFeedback from './ContentItemFeedback';
import FadeIn from './FadeIn';
import stylesForContentitems from './StylesForContentItems';
import Throb from './Throb';

const ContentItem = (props) => {
  // Use the parent's showingCover prop instead of internal state
  const showingCover = props.showingCover;

  const journey = useJourney();
  const { playMedia } = useMediaPlayer();

  const startFeedback = () => {
    props.startFeedback(props.contentitem);
  };

  const pressedCover = () => {
    // Notify parent that this item was opened, parent will manage state
    props.openedItem(props.contentitem.u_id);
  };

  const ci = props.contentitem;

  if (showingCover) {
      let coverText = "";
      if (ci.covertext !== null && ci.covertext !== "") {
        coverText = ci.covertext;
      } else if (props.defaultCoverText !== null) {
        coverText = props.defaultCoverText;
      }
      if (coverText === "") {
        coverText = "Tap For More";
      }
      // for testing and confirming how things work. Remove for live
      //coverText += " " + ci.position;

      const imageSource = iconResourceByName(props.coverImage);

      let delay = 2;

      if (props.totalItems === 1) {
        delay = 1;
      }
      /* *** Comment out for faster testing *** */
      if (AppConstants.skipDelay === false) {
        if (ci.delaytime) {
          delay = ci.delaytime;
        }
      }

      let coverstyle = stylesForContentitems.contentItemCover;
      if (ci.type_id === "prelude") {
        coverstyle = stylesForContentitems.preludeCover;
      } else if (ci.type_id === "caption") {
        coverstyle = stylesForContentitems.captionCover;        
      } else if (ci.type_id === "overture") {
        coverstyle = stylesForContentitems.overtureCover;
      }

      return (
        <FadeIn
          delay={delay}
          growHeight={true}
          growHeightTo={175}
          lastActionTime={props.lastActionTime}
          itemKey={ci.u_id}
        >
          <TouchableOpacity
            onPress={pressedCover}
            underlayColor="white"
          >
            <View style={coverstyle}>
              <Throb>
                <View style={{padding: 10, alignItems: 'center'}}>
                  <Image source={imageSource}
                    style={{width: 80, height: 80}} />
                  <Text style={stylesForContentitems.contentItemCoverText} allowFontScaling={false}>{coverText}</Text>
                </View>
              </Throb>
            </View>
          </TouchableOpacity>
        </FadeIn>
      );
    } else {
      let textStyle = stylesForContentitems.contentItemText;
      if (journey.isShowingLargeText === true) {
        textStyle = stylesForContentitems.contentItemTextLarge;
      }
      if (ci.type_id === "prelude") {
        if (journey.isShowingLargeText === true) {
          textStyle = stylesForContentitems.preludeItemTextLarge;
        } else {
          textStyle = stylesForContentitems.preludeItemText;
        }
      }

      let frameStyle = stylesForContentitems.contentItemFrame;

      return (
        <View style={frameStyle}>
          <View style={{padding: 10,}}>
            {ci.content && <Text style={textStyle}>{ci.content}</Text>}
            {journey.isFeedbackItem(ci) && (<ContentItemFeedback
              contentitem={ci}
              startFeedback={() => startFeedback(ci)} />
            )}
            <ContentImage contentitem={ci} />
            {ci.asset_name && (
              <TouchableOpacity 
                style={styles.playMediaButton}
                onPress={() => playMedia(ci.asset_name)}
              >
                <Ionicons name="play-circle" size={80} color="#007AFF" />
              </TouchableOpacity>
            )}
          </View>
        </View>
      );
    }
};

// React Native needs explicitly named image assets so this is an easy way to get them by the "icon" name
function iconResourceByName(imageName) {
  const namesMap = {
    "Art": require("../../assets/images/Art.png"),
    "Authority": require("../../assets/images/Authority.png"),
    "Belief": require("../../assets/images/Belief.png"),
    "Belonging": require("../../assets/images/Belonging.png"),
    "Change": require("../../assets/images/Change.png"),
    "Empathy": require("../../assets/images/Empathy.png"),
    //"Future": require("../../assets/images/Future.png"),
    "Loneliness": require("../../assets/images/Loneliness.png"),
    "Love": require("../../assets/images/Love.png"),
    "Nostalgia": require("../../assets/images/Nostalgia.png"),
    "Perspective": require("../../assets/images/Perspective.png"),
    "Trauma": require("../../assets/images/Trauma.png")
  };

  let match = namesMap[imageName];
  if (!match) {
    match = require("../../assets/images/Wayfinding.png");
  }

  return match;
}

const ContentImage = ({ contentitem }) => {
  const hasImage = (contentitem) => {
    return (contentitem.image_url && contentitem.image_url !== "/media/original/missing.png");
  };

  if (hasImage(contentitem)) {
    return (
      <View style={{justifyContent: 'center', alignItems: 'center'}}>
        <Image source={{uri: contentitem.image_url}}
               style={{width: 300, height: 300, resizeMode:'contain' }}/>
      </View>
    );
  } else {
    return (<View></View>);
  }
};

const styles = StyleSheet.create({
  playMediaButton: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 15,
    alignSelf: 'center',
  },
});

export default ContentItem;
